import { openToast } from '@component/toast';
import { UserItem } from '@tencent/wemeet-websdk-next';
import wemeetClient from '@utils/wemeetClient';
import { Translation } from 'react-i18next';

interface CoHostChangeData {
  '@xmlns': string;
  /** @description 1 设为； 2 撤销 */
  assign: '1' | '0';
  /** @description HostType.cohost的字符串形式 */
  host_type: '2';
  id: UserItem;
  meeting_code: string;
  meeting_id: string;
}

export const handlerCoHostChange = (data: CoHostChangeData) => {
  const userList = wemeetClient.userCtrl.getUserInfoList();
  const selfId = wemeetClient.userCtrl.getSelfId()['@app_uid'];
  const coHostId = data.id['@app_uid'];

  const fullHost = userList.find((user) => user?.id?.['@app_uid'] === coHostId);

  if (!['0', '1'].includes(data?.assign) || !fullHost) {
    return;
  }

  if (coHostId === selfId) {
    // 联席主持人是自己
    openToast(
      <Translation>
        {(t) => (data.assign === '1' ? t('您已成为联席主持人') : t('主持人已收回您的联席主持人权限'))}
      </Translation>,
    );
  } else {
    console.log('data.assign:', data.assign);
    openToast(
      <Translation>
        {(t) =>
          data.assign === '1'
            ? t('{#nickname#}已成为联席主持人', { nickname: fullHost.nickname })
            : t('已收回{#nickname#}联席主持人权限', { nickname: fullHost.nickname })
        }
      </Translation>,
    );
  }
};
